export default __webpack_public_path__ + "static/media/tiktok_logo.a6474de5.svg";